import { cn } from '@/lib/utils';

interface RecentChangesEntryProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Pierwsza linia, np. „Paczka #12 · wprowadzona”. */
  title: string;
  /** Druga linia: data, autor i wpływ na wartość rezerwacji. */
  meta: string;
}

/** Wpis listy ostatnich zmian — tytuł i wiersz szczegółów pod nim. */
const RecentChangesEntry = ({
  title,
  meta,
  className,
  ...props
}: RecentChangesEntryProps) => (
  <div className={cn('min-w-0', className)} {...props}>
    <div className="text-sm font-semibold text-ink">{title}</div>
    <div className="mt-[3px] text-[13px] text-neutral-500">{meta}</div>
  </div>
);

export default RecentChangesEntry;
